// extracted by mini-css-extract-plugin
export default {"block":"LoadingRow_block__IEzz9"};